export default function productApi() {
	async function FetchCoverPeriod(userType?: string) {
		const { data } = await useAPI<IRequestResponse<string[]>>('/resources/cover-periods', {
			...useApiCache(2000)
		})
		if (data.value?.data) {
			const { setCoverPeriod } = useProductsStore()
			let result = data.value.data
			if (userType === 'business') {
				result = result.filter(item => item !== 'monthly')
			}
			if (result.length) {
				setCoverPeriod(result)
			}
		}
		return data
	}
	return { FetchCoverPeriod }
}
